import axios from "axios";
import { getUserData, isImpersonatingUser, setUserData } from "../common";

// Verified emails only: until the email is confirmed the website shows only
// the "Confirm your email" page (routes.confirmEmail). The sign-in reply and
// GET /profile say emailVerified; the backend answers every other call with
// 403 EMAIL_NOT_VERIFIED.

export const CONFIRM_EMAIL_PATH = "/confirm-email";

export const isEmailUnconfirmed = (userData = getUserData()) =>
  Boolean(userData) && userData.emailVerified === false && !isImpersonatingUser();

const updateStoredUser = (changes) => {
  const userData = getUserData();
  if (!userData || isImpersonatingUser()) return;
  setUserData({ ...userData, ...changes });
};

export const markEmailConfirmed = (email) =>
  updateStoredUser({ emailVerified: true, ...(email && { email }) });

const goToConfirmPage = () => {
  if (!window.location.hash.startsWith(`#${CONFIRM_EMAIL_PATH}`)) {
    window.location.hash = CONFIRM_EMAIL_PATH;
  }
};

// a session from before this change, or an admin changing the email: the
// backend's answer moves the person to the confirm page
export const watchEmailNotVerified = () =>
  axios.interceptors.response.use(undefined, (error) => {
    const { status, data } = error?.response || {};
    if (status === 403 && data?.code === "EMAIL_NOT_VERIFIED") {
      updateStoredUser({ emailVerified: false });
      goToConfirmPage();
      // the confirm page explains it: no "request failed" message from the
      // screen that asked, which is being left anyway
      return new Promise(() => {});
    }
    return Promise.reject(error);
  });

// after a sign-in: true when the person was sent to the confirm page
export const sendToConfirmPageIfNeeded = (userData) => {
  if (!isEmailUnconfirmed(userData)) return false;
  goToConfirmPage();
  return true;
};
